import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=7491ddab&scoped=true&"
import script from "./Contatos.vue?vue&type=script&lang=js&"
export * from "./Contatos.vue?vue&type=script&lang=js&"
import style0 from "./Contatos.vue?vue&type=style&index=0&id=7491ddab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491ddab",
  null
  
)

export default component.exports